export function VirtualAdoptionHero() {
  return (
    <div className="text-center mb-16">
      <h1 className="heading-1 mb-6">
        Adopcja wirtualna
      </h1>
      <div className="relative w-full max-w-4xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-2xl">
        <img
          src="/images/animals/fundacja-znajdki-zwierzeta-011.webp"
          alt="Pies w schronisku – Fundacja Znajdki"
          className="w-full h-64 sm:h-72 md:h-80 lg:h-[500px] xl:h-[600px] object-cover object-center"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
        <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
          <p className="hero-subtitle max-w-2xl mx-auto no-margin">
            Nie możesz adoptować? Zostań wirtualnym opiekunem!
          </p>
        </div>
      </div>
      <p className="body-large max-w-3xl mx-auto">
        Wirtualna adopcja to sposób na pomoc zwierzętom, które z różnych powodów nie mogą znaleźć 
        stałego domu lub potrzebują długotrwałego leczenia.
      </p>
    </div>
  );
}